import React, {Component} from 'react';
import ReactLoadingTop from "../../components/ReactLoadingTop";
import StickButton from "../../components/StickButton";
import {deepCopyObject, hasUserRight, showAxiosError} from "../../helper/helper";
import _ from "lodash";
import Swal from "sweetalert2";
import {isValidSigorta} from "../../common/componentValidation";
import {request} from "../../helper/APIUtils";
import Alert from "react-s-alert";
import moment from "moment/moment";
import {DocumentFrom, UserRightsEnum} from "../../helper/enums";
import MediaViewer from "../einvoice/MediaViewer";
import ExternalCustomer from "../voucher/component/ExternalCustomer";
import ConnectorExternalCustomer from "../invoice/component/ConnectorExternalCustomer";
import ForeignCompanyInfo from "../invoice/component/ForeignCompanyInfo";
import NoIdentifier from "../invoice/component/NoIdentifier";
import Select from "../../local_node_modules/react-select";
import {UncontrolledTooltip} from "reactstrap";
import Datetime from "react-datetime";
import NumberFormat from "react-number-format";
import {Decimal} from "decimal.js";
import NavBarKS from "../../components/NavBarKS";
import {validateField} from "../../common/validation";
import SigortaLines from "./SigortaLines";
import NoteList from "../voucher/component/NoteList";
import SigortaTotalList from "./SigortaTotalList";
import {showConnector, showConnectorPayment} from "../../helper/permission";
import {EntegratorConf} from "../../constants";
import DefaultModal from "../invoice/DefaultModal";
import ConnectorModal from "../connector/ConnectorModal";
import CustomaryPriceModal from "../connector/CustomaryPriceModal";
import ConnectorPaymentModal from "../connector/ConnectorPaymentModal";
import {uuidGenerator} from "../connector/erpHelper";

class CreateEditSigorta extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            saveLoading: false,
            saveType: "saveClose",
            manual: false,
            connectorPaymentModal: false,
            customaryPriceModal: false,
            showConnectorModal: false
        }
        this.fetchSigorta = this.fetchSigorta.bind(this);
        this.getConnectionInfo = this.getConnectionInfo.bind(this);
        this.saveDocument = this.saveDocument.bind(this);
        this.onClickSave = this.onClickSave.bind(this);
        this.showDocument = this.showDocument.bind(this);
        this.handleSend = this.handleSend.bind(this);
        this.setTrdDocSigortaLines = this.setTrdDocSigortaLines.bind(this);
        this.setExternalCustomer = this.setExternalCustomer.bind(this);
        this.setConnectorExternalCustomer = this.setConnectorExternalCustomer.bind(this);
        this.checkUserRights = this.checkUserRights.bind(this);
        this.getInitSigorta = this.getInitSigorta.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
        this.errorListener = this.errorListener.bind(this);
        this.onChangeDateAndCurrency = this.onChangeDateAndCurrency.bind(this);
        this.onChangeDate = this.onChangeDate.bind(this);
        this.validateField = this.validateField.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.getXSLT = this.getXSLT.bind(this);
        this.setTrdDocSigortaNotes = this.setTrdDocSigortaNotes.bind(this);
        this.isManual = this.isManual.bind(this);
        this.setMediaViewer = this.setMediaViewer.bind(this);
        this.getPeriods = this.getPeriods.bind(this);
        this.updatePeriodList = this.updatePeriodList.bind(this);
        this.onChangePeriod = this.onChangePeriod.bind(this);
        this.onChange = this.onChange.bind(this);
        this.checkCustomaryPrice = this.checkCustomaryPrice.bind(this);
        this.checkConnectorPayment = this.checkConnectorPayment.bind(this);
        this.confirmSend = this.confirmSend.bind(this);
    }

    componentDidMount() {
        this.fetchSigorta();
    }

    checkUserRights() {
        if ((this.props.match.params.recordId === "0" && !hasUserRight([UserRightsEnum.sigorta.create], this.props.currentUser))
            || (this.props.match.params.recordId !== "0" && !hasUserRight([UserRightsEnum.sigorta.update], this.props.currentUser))) {
            this.props.history.push("/");
        }
    }

    getConnectionInfo = async () => {
        let self = this;
        let params = {
            url: `/connector/getConnectionInfo`,
            method: "post"
        };
        try {
            let {data} = await request(params);
            if (data != null) {
                self.setState({connectionInfo: data});
            }
        } catch (error) {
            //let err = {response:{data:"Konnektör Bulunamadı"}}
            //showAxiosError(err);
        }
    }

    fetchSigorta() {
        this.checkUserRights();
        let self = this;
        let match = this.props.match;
        let params = {
            url: `/sigorta/edit/${match.params.recordId}`,
            method: "post",
        };
        request(params)
            .then(response => {
                let data = response.data.trdDocSigorta;
                if (!data.externalCustomer) {
                    data.externalCustomer = {
                        commerceChamber: null,
                        customer: null,
                        externalCustomerAddressList: [],
                        familyName: null,
                        formattedName: null,
                        givenName: null,
                        mersisNumber: null,
                        middleName: null,
                        recordId: null,
                        taxOffice: null,
                        title: null,
                        tradeRegistrationNumber: null,
                        vknTckn: null,
                        isForeignCustomer: false,
                    };
                }
                if (!data.externalCustomerAddress) {
                    data.externalCustomerAddress = {
                        buildingName: null,
                        buildingNo: null,
                        cityName: null,
                        citySubdivisionName: null,
                        countryName: null,
                        email: null,
                        fax: null,
                        postalAddressRegion: null,
                        postalAddressRoom: null,
                        postalZone: null,
                        postboxAlias: null,
                        recordId: null,
                        streetName: null,
                        telephone: null,
                        webSite: null
                    };
                }

                self.setState({
                    data: data,
                    initData: deepCopyObject(response.data.trdDocSigorta),
                    charges: response.data.charges,
                    xslts: response.data.xslts,
                    cities: response.data.cities,
                    withholdingTypes: response.data.withholdingTypes,
                    stoppageTypes: response.data.stoppageTypes,
                    countries: response.data.countries,
                    unitCodes: response.data.unitCodes,
                    currencyCodes: response.data.currencyCodes,
                    suffix: (response.data.currencyCodes).find(x => x.shortCode === response.data.trdDocSigorta.documentCurrencyCode).symbol,
                });

            })
            .catch(function (error) {
                showAxiosError(error);
            });

    }

    onClickSave(e, type) {
        e.preventDefault();
        let self = this;
        this.setState({saveLoading: true, saveType: type});
        let data = deepCopyObject(self.state.data);
        if (type === "new") {
            if (!(_.isEqual(data, self.state.initData))) {
                Swal({
                    title: 'Onay',
                    text: 'Sigortadaki değişiklikler kaydedilsin mi?',
                    showCancelButton: true,
                    confirmButtonText: 'Evet',
                    cancelButtonText: 'Hayır',
                    showCloseButton: true,
                    onClose: () => {
                        self.setState({saveLoading: false});
                    }
                }).then((result) => {
                    if (result.value) {
                        self.saveDocument(data, type);
                        Swal.close();
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        Swal.close();
                        self.getInitSigorta("Yeni oluşturuldu.");
                    }
                });
            } else {
                this.getInitSigorta("Yeni oluşturuldu.");
            }
        } else if (type === "look") {
            this.showDocument();
        } else if (type === "save") {
            self.saveDocument(data, type);
        } else if (type === "saveClose") {
            self.saveDocument(data, type);
        } else if (type === "directSend") {
            this.saveDocument(data, type);
        } else if (type === "saveSend") {
            //Hatalı faturanın düzenlenmiş halini gönderiyoruz.
            if (data.deletedAt)
                self.sendIncorrectSigorta();
            else
                self.setState({saveLoading: false});
        } else {
            self.setState({saveLoading: false});
        }
    }

    showDocument() {
        let self = this;
        let data = deepCopyObject(self.state.data);
        let match = self.props.match;
        let result = isValidSigorta(data, match.params.direction);
        let error = result.error;
        let valid = result.valid;
        let item = data;
        if (valid) {
            let params = {
                url: "/sigorta/showDocument",
                responseType: 'arraybuffer',
                method: 'post',
                data: data
            };
            self.setState({mediaModal: true, title: item.documentUuid});

            request(params)
                .then(response => {
                    let blob = new Blob([response.data], {type: response.headers["content-type"]});
                    let urlCreator = window.URL || window.webkitURL;
                    let url = urlCreator.createObjectURL(blob);
                    self.setState({url: url, saveLoading: false});
                })
                .catch(function (error) {
                    self.setState({saveLoading: false});
                    showAxiosError(error);
                });
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
            self.setState({
                error,
                saveLoading: false,
                activeTab: result.activeTab,
                hTabs: result.hTabs
            });
        }
    }

    saveDocument(data, type) {
        let self = this;
        let match = self.props.match;
        let result = isValidSigorta(data);
        let error = result.error;
        let valid = result.valid;
        if (valid) {
            if (!data["from"]) {
                data["from"] = DocumentFrom.PORTAL;
            }

            let params = {
                url: `/sigorta/save/${match.params.recordId}`,
                method: "post",
                data: data
            };
            request(params)
                .then(response => {
                    let data = response.data;
                    self.setState({saveLoading: false, data: data, initData: deepCopyObject(data)});
                    if (type === "saveClose") {
                        Alert.success('Kaydedildi', {
                            position: 'top-right',
                            effect: 'stackslide',
                            timeout: 2000
                        });
                        self.setState({saveLoading: false});
                        self.props.history.push("/sigortaTmp");
                    } else if (type === "directSend") {
                        self.handleSend(data);
                    } else if (type === "new") {
                        this.getInitSigorta("Kaydedildi");
                    }
                    if (type !== "new") {
                        Alert.closeAll();
                        Alert.success('Kaydedildi', {
                            position: 'top-right',
                            effect: 'stackslide',
                            timeout: 2000
                        });
                    }
                })
                .catch(function (error) {
                    self.setState({saveLoading: false});
                    showAxiosError(error);
                });
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
            self.setState({error, saveLoading: false});
        }
    }

    getInitSigorta(info) {
        let self = this;
        let params = {
            url: `/sigorta/edit/-1`,
            method: "post"
        };
        request(params)
            .then(response => {
                Alert.closeAll();
                Alert.success(info, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
                let data = response.data.trdDocSigorta;
                self.setState({data: data, initData: deepCopyObject(data), saveLoading: false, manual: true});
            })
            .catch(function (error) {
                self.setState({saveLoading: false});
                showAxiosError(error);
            });
    }

    sendIncorrectSigorta() {
        let self = this;
        let match = self.props.match;
        let item = self.state.data;
        let result = isValidSigorta(item, match.params.direction);
        let error = result.error;
        let valid = result.valid;
        if (valid) {
            let params = {
                url: `/sigorta/update`,
                method: 'post',
                data: item
            };

            self.setState({saveLoading: true});
            request(params)
                .then(function (response) {
                    self.setState({saveLoading: false});
                    self.props.history.push(`/sigortaList`);
                    Alert.closeAll();
                    Alert.success("Düzenlenmiş sigorta başarılı şekilde gönderildi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 2000
                    });
                }).catch(function (error) {
                self.setState({saveLoading: false});
                showAxiosError(error);
            });
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
            self.setState({error, saveLoading: false});
        }
    }

    handleSend(item) {
        let self = this;
        let params = {
            url: `/sigorta/getPrefixCode/${item.recordId}`,
            method: 'post'
        };

        self.setState({reactLoading: true});
        request(params)
            .then(function (response) {
                let prefixCodes = response.data;
                self.setState({
                    showSendSwal: true,
                    prefixCodes: prefixCodes,
                    documentId: prefixCodes[0].value,
                    lastIssueDate: prefixCodes[0].lastIssueDate,
                    item: item,
                });

            }).catch(function (error) {
            showAxiosError(error);
        }).then(function () {
            self.setState({reactLoading: false});
        });
    }

    onChangeValue(e) {
        let data = deepCopyObject(this.state.data);
        const {name, value} = e;
        if (name === "retailCustomer") {
            if (value) {
                //data.externalCustomer = {};
                //data.externalCustomerAddress = {};
            } else {
                data.trdDocExternalCustomer = null;
            }
        }
        if (name === "hasForeignCustomer") {
            data.externalCustomer = {
                buyerType: null,
                city: null,
                commerceChamber: null,
                customer: null,
                customerCode: null,
                customerRiskLimit: null,
                customerType: 2,
                externalCustomerAddressList: [],
                externalCustomerBankList: [],
                familyName: null,
                formattedName: null,
                givenName: null,
                initialBalance: null,
                mersisNumber: null,
                middleName: null,
                recordId: null,
                taxOffice: null,
                title: null,
                tradeRegistrationNumber: null,
                vknTckn: null
            };
            data.externalCustomerAddress = {
                buildingName: null,
                buildingNo: null,
                cityName: null,
                citySubdivisionName: null,
                countryName: null,
                email: null,
                fax: null,
                postalAddressRegion: null,
                postalAddressRoom: null,
                postalZone: null,
                postboxAlias: null,
                recordId: null,
                streetName: null,
                telephone: null,
                webSite: null
            };
        }
        data[name] = value;
        this.setState({data});

    }

    setExternalCustomer(externalCustomer, externalCustomerAddress) {
        let data = deepCopyObject(this.state.data);
        data["externalCustomer"] = externalCustomer;
        data["externalCustomerAddress"] = externalCustomerAddress;
        this.setState({data});
    }

    errorListener(tError) {
        let error = this.state.error;
        error = Object.assign(error, tError);
        this.setState({error});
    }

    setConnectorExternalCustomer = (externalCustomer) => {
        let data = deepCopyObject(this.state.data);
        data["tmpDocConnectorExCustomer"] = externalCustomer;
        this.setState({data});
    }

    async onChangeDateAndCurrency(momentObj, name, currencyCode, forexType) {
        this.setState({changeDate: true});
        await this.onChangeDate(momentObj, name);
        this.onChangeCurrency(currencyCode ? {value: currencyCode} : {value: "TRY"}, forexType && forexType === "Satış" ? "ForexSelling" : "ForexBuying");
    }

    onChangeCurrency(e, label) {
        let data = deepCopyObject(this.state.data);
        let self = this;
        data["documentCurrencyCode"] = e.value;
        if (data["documentCurrencyCode"] === "TRY") {
            this.setState({
                data,
                suffix: (self.state.currencyCodes).find(x => x.shortCode === data['documentCurrencyCode']).symbol,
                manual: true
            });
            return;
        }
        let issueDate = moment(this.state.data.issueDate).format("YYYY-MM-DD");
        let options = {
            code: e.value,
            date: issueDate
        };
        let params = {
            url: `/common/getCurrencyValue/${options.code}/${options.date}`,
            method: "post",
        };
        request(params)
            .then(response => {
                let forex = response.data;
                data['paymentExchangeRate'] = forex[label];
                self.setState({
                    forex: forex,
                    data: data,
                    suffix: (self.state.currencyCodes).find(x => x.shortCode === data['documentCurrencyCode']).symbol,
                    manual: true
                });
            })
            .catch(function (error) {
                let forex = {ForexSelling: "0.00", ForexBuying: "0.00"};
                data['paymentExchangeRate'] = forex[label];
                self.setState({
                    forex: forex,
                    data: data,
                    suffix: (self.state.currencyCodes).find(x => x.shortCode === data['documentCurrencyCode']).symbol
                });
                showAxiosError(error);
            });
    }

    onChangeDate(momentObj, name) {
        let data = deepCopyObject(this.state.data);
        if (!(typeof momentObj === "string")) {
            if (name === "date") {
                let date = momentObj.format("YYYY-MM-DD");
                let time = moment(data.issueDate).format("HH:mm:ss");
                data.issueDate = moment(date + "T" + time).format("YYYY-MM-DDTHH:mm:ss");
                this.setState({data}, ()=>this.updatePeriodList(data));
            } else if (name === "time") {
                let time = momentObj.format("HH:mm:ss");
                let date = moment(data.issueDate).format("YYYY-MM-DD");
                data.issueDate = moment(date + "T" + time).format("YYYY-MM-DDTHH:mm:ss");
                this.setState({data}, ()=>this.updatePeriodList(data));
            } else {
            }
        } else {
        }
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = validateField(rule, boundary, e.target.value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    setChangeDate() {
        this.setState({changeDate: false});
    }

    setTrdDocSigortaLines(trdDocSigortaLines) {
        let data = deepCopyObject(this.state.data);
        data['trdDocSigortaLines'] = trdDocSigortaLines;
        data = CreateEditSigorta.calculateTotal(data);
        this.setState({data});
    }

    getXSLT() {
        let xslts = this.state.xslts.filter(xslt => xslt.xsltType === "ESIGORTA");
        let xslt = xslts.find(x => x.isDefault === 1);
        if (xslt) {
            this.onChangeValue({name: "xsltPath", value: (xslt.xsltFilepath)});
        } else {
            if (xslts && xslts instanceof Array && xslts.length > 0)
                this.onChangeValue({name: "xsltPath", value: (xslts[xslts.length - 1].xsltFilepath)});
            else
                this.onChangeValue({name: "xsltPath", value: null});
        }
    }

    setTrdDocSigortaNotes(trdDocSigortaNotes) {
        let data = deepCopyObject(this.state.data);
        data['trdDocSigortaNotes'] = trdDocSigortaNotes;
        this.setState({data});
    }

    static calculateTotal(tData) {
        let data = deepCopyObject(tData);
        let trdDocSigortaLines = data.trdDocSigortaLines;
        let chargeTotalAmount = new Decimal(0.00);
        let allowanceTotalAmount = new Decimal(0.00);
        for (let i = 0; i < trdDocSigortaLines.length; i++) {
            let trdDocSigortaLine = trdDocSigortaLines[i];
            chargeTotalAmount = chargeTotalAmount.add(new Decimal(trdDocSigortaLine.cancelCommissionPrice));
            allowanceTotalAmount = allowanceTotalAmount.add(new Decimal(trdDocSigortaLine.productCommissionPrice));

        }
        data.chargeTotalAmount = new Decimal(chargeTotalAmount.toFixed(2, Decimal.ROUND_HALF_UP)).toNumber();
        data.allowanceTotalAmount = new Decimal(allowanceTotalAmount.toFixed(2, Decimal.ROUND_HALF_UP)).toNumber();
        return data;
    }

    isManual(manual) {
        this.setState({manual});
    }

    setMediaViewer() {
        this.setState({url: null, mediaModal: false});
    }

    getPeriods() {
        let data = deepCopyObject(this.state.data);
        return this.state.periods &&  this.state.periods.length>0 ? this.state.periods : this.updatePeriodList(data);
    }

    updatePeriodList(data) {
        let startOfMonth = moment(data.issueDate).startOf('month').format("YYYY-MM-DD");
        let middleOf15Month = moment(data.issueDate).format("YYYY-MM-15");
        let middleOf16Month = moment(data.issueDate).format("YYYY-MM-16");
        let endOfMonth = moment(data.issueDate).endOf('month').format("YYYY-MM-DD");

        let startOfPreviousMonth = moment(data.issueDate).subtract(1, 'months').startOf('month').format("YYYY-MM-DD");
        let middleOf15PreviousMonth = moment(data.issueDate).subtract(1, 'months').format("YYYY-MM-15");
        let middleOf16PreviousMonth = moment(data.issueDate).subtract(1, 'months').format("YYYY-MM-16");
        let endOfPreviousMonth = moment(data.issueDate).subtract(1, 'months').endOf('month').format("YYYY-MM-DD");

        let periods = [
            {
                label: "(" + moment(startOfPreviousMonth).format("DD-MM-YYYY") + ")-(" + moment(middleOf15PreviousMonth).format("DD-MM-YYYY") + ")",
                value: startOfPreviousMonth + "T00:00:00" + "." + middleOf15PreviousMonth + "T23:59:59"
            },
            {
                label: "(" + moment(middleOf16PreviousMonth).format("DD-MM-YYYY") + ")-(" + moment(endOfPreviousMonth).format("DD-MM-YYYY") + ")",
                value: middleOf16PreviousMonth+ "T00:00:00" + "." + endOfPreviousMonth+ "T23:59:59"
            },
            {
                label: "(" + moment(startOfPreviousMonth).format("DD-MM-YYYY") + ")-(" + moment(endOfPreviousMonth).format("DD-MM-YYYY") + ")",
                value: startOfPreviousMonth+ "T00:00:00" + "." + endOfPreviousMonth+ "T23:59:59"
            },
            {
                label: "(" + moment(startOfMonth).format("DD-MM-YYYY") + ")-(" + moment(middleOf15Month).format("DD-MM-YYYY") + ")",
                value: startOfMonth+ "T00:00:00" + "." + middleOf15Month+ "T23:59:59"
            },
            {
                label: "(" + moment(middleOf16Month).format("DD-MM-YYYY") + ")-(" + moment(endOfMonth).format("DD-MM-YYYY") + ")",
                value: middleOf16Month + "T00:00:00"+ "." + endOfMonth+ "T23:59:59"
            },
            {
                label: "(" + moment(startOfMonth).format("DD-MM-YYYY") + ")-(" + moment(endOfMonth).format("DD-MM-YYYY") + ")",
                value: startOfMonth + "T00:00:00"+ "." + endOfMonth+ "T23:59:59"
            }
        ];

        this.setState({periods});
    }

    onChangePeriod(e) {
        let data = deepCopyObject(this.state.data);
            let {value} = e;
            data["periodStartDateTime"] = value.split(".")[0];
            data["periodEndDateTime"] = value.split(".")[1];
        console.log(data)
        this.setState({data});
    }

    onChange(e, label) {
        if (label === "ForexBuying") {
            this.setState({forexType: "Alış"});
        } else {
            this.setState({forexType: "Satış"});
        }

        let data = deepCopyObject(this.state.data);
        if (data.forex === undefined || data.forex[label] === undefined) {
            this.onChangeCurrency({value: data.documentCurrencyCode}, label);
        } else {
            data['paymentExchangeRate'] = this.state.forex[label];
            this.setState({data});
        }
    }

    async checkCustomaryPrice() {
        let self = this;
        let result = await self.checkConnectorPayment();
        const propType = result.checkPropType ? result.checkPropType : [];
        if((propType.length !== 0 || result.checkUpdated === true || result.checkInstallation === true) && showConnectorPayment(EntegratorConf.identifier) && this.props.currentUser.parentCustomerWorkType === 2 && this.props.currentUser.isParentCustomerDistributor){
            Alert.error('Bayiniz ile ödeme için görüşünüz.', {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html:false
            });
        }else if((propType.length !== 0 || result.checkUpdated === true || result.checkInstallation === true) && showConnectorPayment(EntegratorConf.identifier)){
            this.setState({connectorPaymentModal: true});
        }else {
            if (showConnectorPayment(EntegratorConf.identifier)) {
                let params = {
                    url: `/connector/fetchErpPaymentInformation`,
                    method: "get"
                };
                request(params)
                    .then(function (response) {
                        let data = response.data;
                        if ((propType.length !== 0 || result.checkUpdated === true || result.checkInstallation === true) && showConnectorPayment(EntegratorConf.identifier)) {
                            self.setState({customaryPriceModal: true});
                        } else {
                            self.setState({showConnectorModal: true});
                        }
                    }).catch(function (error) {
                    showAxiosError(error);
                });
            } else {
                self.setState({showConnectorModal: true});
            }
        }
    }

    checkConnectorPayment(){
        return new Promise((resolve) => {
            let propType = "sigorta";
            let params = {
                url: `/connector/checkConnectorPayment?propType=${propType}`,
                method: "get"
            };
            request(params).then((response) => {
                let result = response.data;
                resolve(result);
            })
        });
    }

    confirmSend() {
        let self = this;
        let data = self.state.data;
        console.log(data, this.state.documentId, this.state.lastIssueDate)
        let params = {
            url: `/sigorta/send`,
            method: 'post',
            data: {
                recordId: data.recordId,
                documentId: this.state.documentId,
                lastIssueDate: this.state.lastIssueDate
            }
        };

        self.setState({sendBtnDisabled: true});
        request(params)
            .then(function (response) {
                self.updateSigortaNumberWs(data.recordId);
                self.setState({showSendSwal: false, sendBtnDisabled: false, manual: true});
                Alert.success(response.data, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
                self.props.history.push(`/sigortaList`);
            }).catch(function (error) {
            self.setState({sendBtnDisabled: false, showSendSwal: false});
            showAxiosError(error);
        });
    }

    updateSigortaNumberWs = async (recordId) =>{
        let self = this;
        const {connectionInfo} = self.state;
        if(connectionInfo!=null && connectionInfo.connectionType === "WEBSOCKET"){
            self.handleWebsocket();
            let params = {
                url: `/connector/getUpdateSql/${recordId}/sigorta`,
                method: "post"
            };
            try{
                let {data} = await request(params);
                if(data) {
                    self.sendWebsocketMessage(data, "UPDATE_SIGORTA_NUMBER")
                }
            }catch(error){
                let err = {response:{data:error.toString()}}
                showAxiosError(err);
            }
        }
    }

    sendWebsocketMessage = async (query,queryType,documentUuid) =>{
        let ws = this.state.ws;
        if(ws.readyState !== 1){
            await new Promise(r => setTimeout(r, 1000));
        }
        if ( ws.readyState === 3 ) {
            ws.close();
            this.handleWebsocket();
            while (ws.readyState !== 1) {
                await new Promise(r => setTimeout(r, 1000));
            }
        }
        const {connectionInfo} = this.state;
        const {currentUser} = this.props;

        let header = {
            customerId: currentUser.customerId,
            dataSource: connectionInfo.dataSource,
            initialCatalog: connectionInfo.initialCatalog,
            dbUser: connectionInfo.dbUser,
            dbPassword: connectionInfo.dbPassword,
            key: connectionInfo.key,
            branchId: connectionInfo.branchId,
            clientType:"PORTAL"
        }
        let body = {
            uuid:documentUuid?documentUuid: uuidGenerator(),
            queryType: queryType,
            query: query
        };

        let jsonMsg = JSON.stringify({header,body})
        ws.send(jsonMsg);
    }

    handleWebsocket = () =>{
        const {connectionInfo} = this.state;
        let ip = connectionInfo.ownerIp + "/websocket/chat";
        const ws = new WebSocket(ip);
        this.setState({ws});
        ws.onopen = () => {
            console.log("connected")
        }

        ws.onmessage = evt => {
            let {queryType,rows,uuid} = JSON.parse(evt.data)
            rows = JSON.parse(rows);
            if(queryType == "ERROR" && rows && rows[0].error){
                console.log(rows[0].error);
                this.setState({searching:false})
            }else if((queryType === "UPDATE_SIGORTA_NUMBER") && rows != null){
                let documentId = rows[0].documentId;
                if(documentId!=null ){
                    let params = {
                        url: `/connector/updateSqlHistory/sigorta/${documentId}`,
                        method: "post"
                    };
                    let {data} = request(params);
                }
            }
        }
        ws.onclose = () => {
            console.log("connected")
        }
    }

    render() {
        const isCreditSufficient = this.state.isCreditSufficient!=undefined?this.state.isCreditSufficient:true;
        if (!this.state.data)
            return (<ReactLoadingTop style={{width: "90px", height: "90px"}}/>);
        return (
            <div className="row baseBackground">
                {!this.state.data.deletedAt &&
                    <NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}
                              name={"sigortaTmp"}>
                        <StickButton position="leftSide"
                                     title="Yeni"
                                     label={this.state.saveType === "new" && this.state.saveLoading ? "Oluşturuluyor..." : "Yeni"}
                                     disabled={this.state.saveLoading}
                                     className="stickButton plus-circle"
                                     icon='plus-circle'
                                     style={{marginRight: '2px'}}
                                     onClick={(e) => this.onClickSave(e, "new")}/>

                        <StickButton position="leftSide"
                                     title="Goster"
                                     label={this.state.saveType === "Goster" && this.state.saveLoading ? "Oluşturuluyor..." : "Sigortayı Göster"}
                                     disabled={this.state.saveLoading}
                                     className="stickButton observe"
                                     icon='observe'
                                     style={{marginRight: '2px'}}
                                     onClick={(e) => this.onClickSave(e, "look")}/>

                        <StickButton position="leftSide"
                                     title="Direkt Gönder"
                                     label={this.state.saveType === "directSend" && this.state.saveLoading ? "Gönderiliyor..." : "Direkt Gönder"}
                                     disabled={!isCreditSufficient || (this.state.saveLoading || !hasUserRight(UserRightsEnum.sigorta.send, this.props.currentUser))}
                                     className="stickButton send"
                                     onClick={(e) => this.onClickSave(e, "directSend")}
                                     icon="send"/>
                        {(showConnector(EntegratorConf.identifier)  && hasUserRight(UserRightsEnum.ekonnektor.view,this.props.currentUser))&&
                            <StickButton position="leftSide"
                                         title="ERP'den Getir"
                                         label="ERP'den Getir"
                                         type="invoice"
                                         className="stickButton arrow-down"
                                         onClick={this.checkCustomaryPrice}
                                         disabled={!isCreditSufficient || !(hasUserRight(UserRightsEnum.ekonnektor.view,this.props.currentUser))}
                                         icon="arrow-down"/>
                        }

                        <StickButton position="rightSide"
                                     title="Kaydet"
                                     label={this.state.saveType === "save" && this.state.saveLoading ? "Kaydediliyor..." : "Kaydet"}
                                     disabled={this.state.saveLoading}
                                     className="stickButton save"
                                     icon='save'
                                     onClick={(e) => this.onClickSave(e, "save")}/>

                        <StickButton position="rightSide"
                                     title="Kaydet & Kapat"
                                     label={this.state.saveType === "saveClose" && this.state.saveLoading ? "Kaydediliyor..." : "Kaydet & Kapat"}
                                     disabled={this.state.saveLoading}
                                     className="stickButton terminate"
                                     icon='terminate'
                                     onClick={(e) => this.onClickSave(e, "saveClose")}/>
                    </NavBarKS>
                }

                {this.state.mediaModal &&
                    <MediaViewer modal={this.state.mediaModal}
                                 url={this.state.url}
                                 title={this.state.title}
                                 listener={this.setMediaViewer}
                    />
                }

                {this.state.showSendSwal &&
                    <DefaultModal
                        disabled={this.state.sendBtnDisabled}
                        isOpen={this.state.showSendSwal}
                        title={"Kullanmak İstediğiniz Öneki Seçiniz"}
                        confirmBtnText="Gönder"
                        cancelBtnText="İptal"
                        onConfirm={this.confirmSend}
                        onCancel={(e) => this.setState({showSendSwal: false})}
                    >
                        <div className="col-sm-12">
                            <h5 style={{
                                fontFamily: 'Century Gothic',
                                fontSize: '1em',
                                fontWeight: 100,
                                textAlign: "center"
                            }}
                                className="text-danger">{this.state.documentId}</h5>
                        </div>
                        <div className="col-sm-12">
                            <Select
                                value={this.state.documentId}
                                clearable={false}
                                placeholder="Seçiniz..."
                                noResultsText="Kayıt bulunamadı."
                                onChange={(e) => this.setState({
                                    documentId: e.value,
                                    lastIssueDate: e.lastIssueDate
                                })}
                                options={this.state.prefixCodes.map(prefixCode => ({
                                    value: prefixCode.value,
                                    label: prefixCode.label,
                                    lastIssueDate: prefixCode.lastIssueDate
                                }))}
                            />
                        </div>
                    </DefaultModal>}

                {this.state.showConnectorModal &&
                    <ConnectorModal
                        modal={this.state.showConnectorModal}
                        type="sigorta"
                        modalType={'get'}
                        currentUser={this.props.currentUser}
                        toggleModal={(showConnectorModal, manual) => this.setState({showConnectorModal, manual})}
                    />
                }
                {this.state.customaryPriceModal &&
                    <CustomaryPriceModal modal={this.state.customaryPriceModal}
                                         toggle={(flag, manual) => this.setState({customaryPriceModal: flag, manual:manual})}
                                         paymentInfo={this.state.paymentInfo}
                                         paytrDomain={this.props.currentUser.paytrDomain}/>
                }

                {this.state.connectorPaymentModal &&
                    <ConnectorPaymentModal modal={this.state.connectorPaymentModal}
                                           toggle={(flag, manual) => this.setState({connectorPaymentModal: flag, manual:manual})}
                                           paymentInfo={this.state.paymentInfo}
                                           currentUser={this.props.currentUser}/>
                }

                <div className="col-sm-12 satirBasi">
                    <div className="row card-header">
                        <h4 className="baslik card-title">Sigorta </h4>
                    </div>
                    <div className="">
                        <div className="headerTextStyle ettn" style={{paddingBottom: '25px', fontSize: '0.9em'}}>
                            <div className="col-sm-6 col-lg-6 row"> ETTN : {this.state.data.documentUuid}</div>
                        </div>
                    </div>

                    <div className="col-sm-12">
                        <div className="row baseDashboard">
                            <div className="col-sm-7">
                                <div className="card-header">
                                    <div className="row" style={{marginLeft: "-30px", marginRight: "-75px"}}>
                                        <div className="col-sm-8">
                                            <h4 className="card-title">{this.state.data.hasForeignCustomer ? "Yabancı Alıcı Bilgileri" : "Alıcı Bilgileri"}</h4>
                                        </div>
                                        <div className="col-sm-4 row">
                                            {
                                                <div className="col-sm-12">
                                                    <label style={{whiteSpace: "nowrap"}}>Yabancı Müşteri</label>
                                                    <input type="checkbox"
                                                           checked={this.state.data.hasForeignCustomer}
                                                           style={{float: "right"}}
                                                           disabled={this.state.data.retailCustomer}
                                                           onChange={(e) => e && this.onChangeValue({
                                                               name: "hasForeignCustomer",
                                                               value: e.target.checked
                                                           })}/>
                                                </div>
                                            }

                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    {this.state.data && this.state.data.externalCustomer && !this.state.data.hasForeignCustomer && !this.state.data.retailCustomer &&
                                        <div className="card-body" style={{marginLeft: '-30px', marginRight: '-75px'}}>
                                            <ExternalCustomer listener={this.setExternalCustomer}
                                                              requiredTaxOffice={false}
                                                              errorListener={this.errorListener}
                                                              checkGibUser={false}
                                                              error={this.state.error}
                                                              title={"Müşteri Bilgileri"}
                                                              cities={this.state.cities}
                                                              includeForeign={false}
                                                              docType={this.props.match.params.type}
                                                              invoiceTypeCode={this.state.data.documentTypeCode}
                                                              externalCustomer={this.state.data.externalCustomer}
                                                              countries={this.state.countries}
                                                              externalCustomerAddress={this.state.data.externalCustomerAddress}
                                                              currentUser={this.props.currentUser}
                                            />
                                        </div>
                                    }
                                    {this.state.data.from === "CONNECTOR" && (
                                        <ConnectorExternalCustomer
                                            listener={this.setConnectorExternalCustomer}
                                            cities={this.state.cities}
                                            countries={this.state.countries}
                                            externalCustomer={this.state.data.tmpDocConnectorExCustomer}
                                            docType={this.state.data.profileId}
                                        />
                                    )}
                                    {(this.state.data.hasForeignCustomer) &&
                                        <ForeignCompanyInfo
                                            listener={this.setExternalCustomer}
                                            errorListener={this.errorListener}
                                            error={this.state.error}
                                            cities={this.state.cities}
                                            includeForeign={false}
                                            countries={this.state.countries}
                                            externalCustomer={this.state.data.externalCustomer}
                                            externalCustomerAddress={this.state.data.externalCustomerAddress}/>
                                    }
                                    {this.state.data.retailCustomer &&
                                        <NoIdentifier
                                            {...this.props}
                                            docExternalCustomer={this.state.data.trdDocExternalCustomer}
                                            listener={this.setDocExternalCustomer}
                                            countries={this.state.countries}
                                            cities={this.state.cities}
                                        />
                                    }
                                </div>
                            </div>
                            <hr></hr>
                            <div className="col-sm-5 row">
                                <div className="card-header">
                                    <h4 className="card-title"> Sigorta Bilgileri</h4>
                                </div>
                                <div className="col-sm-12 row">
                                    <div className="card-body">
                                        <div className="row">
                                            <label className="col-sm-4 col-lg-6 col-form-label">Gönderim Şekli *</label>
                                            <div className="col-sm-8 col-lg-6">
                                                <div className={"form-group" + this.validateClass('sendingType')}>
                                                    <Select
                                                        id="sendingType"
                                                        clearable={false}
                                                        placeholder="Seçiniz..."
                                                        noResultsText="Kayıt bulunamadı."
                                                        value={this.state.data.sendingType === null ? undefined : this.state.data.sendingType}
                                                        onBlur={() => this.validateField({
                                                            target: {
                                                                id: "sendingType",
                                                                dataset: {'vlength': "1,45"},
                                                                value: this.state.data.sendingType
                                                            }
                                                        })}
                                                        options={[
                                                            {label: "Kağıt", value: "KAGIT"},
                                                            {label: "Elektronik", value: "ELEKTRONIK"}
                                                        ]}
                                                        onChange={(e) => e && this.onChangeValue({
                                                            name: "sendingType",
                                                            value: e.value
                                                        })}
                                                    />
                                                    {this.validateMessage('sendingType') !== "" &&
                                                        <UncontrolledTooltip placement="right" target="sendingType"
                                                                             delay={0}>
                                                            {this.validateMessage("sendingType")}
                                                        </UncontrolledTooltip>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <label className="col-sm-4 col-lg-6 col-form-label">Düzenlenme Tarihi
                                                *</label>
                                            <div className="col-sm-8 col-lg-6">
                                                <div className={"form-group" + this.validateClass('issueDate')}>
                                                    <Datetime locale="tr"
                                                              className="datepicker"
                                                              input={true}
                                                              inputProps={{id: 'issueDate'}}
                                                              closeOnSelect={true}
                                                              value={moment(this.state.data.issueDate)}
                                                              defaultValue={moment()}
                                                              dateFormat="DD-MM-YYYY"
                                                              timeFormat={false}
                                                              isValidDate={function (current) {
                                                                  return current.isBefore(Datetime.moment());
                                                              }}
                                                              onChange={(e) =>
                                                                  this.onChangeDateAndCurrency(e, "date", this.state.data.documentCurrencyCode, this.state.forexType)}/>
                                                    {this.validateMessage('issueDate') !== "" &&
                                                        <UncontrolledTooltip placement="right" target="issueDate"
                                                                             delay={0}>
                                                            {this.validateMessage("issueDate")}
                                                        </UncontrolledTooltip>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <label className="col-sm-4 col-lg-6 col-form-label">Düzenlenme Saati
                                                *</label>
                                            <div className="col-sm-8 col-lg-6">
                                                <div className={"form-group" + this.validateClass('issueTime')}>
                                                    <Datetime locale="tr"
                                                              className="timepicker"
                                                              inputProps={{id: 'issueTime'}}
                                                              input={true}
                                                              value={moment(this.state.data.issueDate)}
                                                              defaultValue={moment()}
                                                              dateFormat={false} timeFormat={true}
                                                              onChange={(e) => this.onChangeDate(e, "time")}/>
                                                    {this.validateMessage('issueTime') !== "" &&
                                                        <UncontrolledTooltip placement="right" target="issueTime"
                                                                             delay={0}>
                                                            {this.validateMessage("issueTime")}
                                                        </UncontrolledTooltip>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row ">
                                            <label
                                                className="col-sm-12 col-lg-6 col-form-label">Dönem
                                                Bilgisi *</label>
                                                <div className="col-sm-12 col-lg-6">
                                                    <div
                                                        className={"form-group" + this.validateClass('periodStartDate')}>
                                                        <Select
                                                            id="periodStartDate"
                                                            clearable={false}
                                                            placeholder="Dönemi Seçiniz..."
                                                            noResultsText="Kayıt bulunamadı."
                                                            value={this.state.data.periodStartDateTime + "." + this.state.data.periodEndDateTime}
                                                            options={this.getPeriods()}
                                                            onChange={(e) => e && this.onChangePeriod({
                                                                value: e.value
                                                            })}
                                                        />
                                                    </div>
                                                </div>
                                        </div>
                                        <div className="row">
                                            <label className="col-sm-4 col-lg-6 col-form-label">Para Birimi*</label>
                                            <div
                                                className={"col-sm-" + (this.state.data.documentCurrencyCode === "TRY" ? "8" : "4") + "  col-lg-" + (this.state.data.documentCurrencyCode === "TRY" ? "6" : "4")}>
                                                <div className="form-group">
                                                    <Select
                                                        id="documentCurrencyCode"
                                                        clearable={false}
                                                        placeholder="Seçiniz..."
                                                        noResultsText="Kayıt bulunamadı."
                                                        value={this.state.data.documentCurrencyCode === null ? this.onChangeCurrency({value: "TRY"}, "ForexBuying") : this.state.data.documentCurrencyCode}
                                                        style={{width: "100%"}}
                                                        onChange={(e) => this.onChangeCurrency({value: e.value}, "ForexBuying")}
                                                        onBlur={() => this.validateField({
                                                            target: {
                                                                id: "documentCurrencyCode",
                                                                dataset: {'vlength': "1,45"},
                                                                value: this.state.data.documentCurrencyCode
                                                            }
                                                        })}
                                                        options={this.state.currencyCodes.map(currencyCode => ({
                                                            value: currencyCode.shortCode,
                                                            label: currencyCode.longCode
                                                        }))}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                this.state.data.documentCurrencyCode !== "TRY" &&
                                                <div className="col-sm-3 col-lg-2" style={{
                                                    display: (this.state.data.documentCurrencyCode === "TRY" ? 'none' : ''),
                                                    padding: '0px 0px 0px 1px'
                                                }}>
                                                    <div className="dropdown">
                                                        <button className="btn btn-secondary dropdown-toggle"
                                                                type="button"
                                                                style={{margin: 0, padding: "4px 9px"}}
                                                                id="dropdownMenuButton"
                                                                data-toggle="dropdown"
                                                                aria-haspopup="true"
                                                                aria-expanded="false">
                                                            {this.state.forexType || "Alış"}
                                                        </button>
                                                        <div className="dropdown-menu"
                                                             aria-labelledby="dropdownMenuButton">
                                                            <a className="dropdown-item"
                                                               onClick={(e) => this.onChange(e, "ForexBuying")}>Alış</a>
                                                            <a className="dropdown-item"
                                                               onClick={(e) => this.onChange(e, "ForexSelling")}>Satış</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                        {
                                            this.state.data.documentCurrencyCode !== "TRY" &&
                                            <div className="row">
                                                <label className="col-sm-4 col-lg-6  col-form-label">Kur Değeri *</label>
                                                <div className="col-sm-8 col-lg-6">
                                                    <div className="form-group">
                                                        <NumberFormat
                                                            value={this.state.data.paymentExchangeRate}
                                                            allowNegative={false}
                                                            isNumericString={true}
                                                            thousandSeparator={'.'}
                                                            decimalSeparator={','}
                                                            suffix={this.state.suffix}
                                                            displayType="input"
                                                            isAllowed={values => {
                                                                return (values.value === "" ? false : true);
                                                            }}
                                                            placeholder="Kur Değeri"
                                                            renderText={value => {
                                                                value.replace(/\./g, ',')
                                                            }}
                                                            onValueChange={(e) => this.onChangeValue({
                                                                name: 'paymentExchangeRate',
                                                                value: e.value
                                                            })}
                                                            className="form-control"/>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {
                                            <div className="row">
                                                <label className="col-sm-4 col-lg-6 col-form-label"
                                                       style={{whiteSpace: 'nowrap'}}>XSLT Dosyası:</label>
                                                <div className="col-sm-8 col-lg-6">
                                                    <div className={"form-group" + this.validateClass('xsltPath')}>
                                                        <Select
                                                            name="xsltPath"
                                                            value={this.state.data.xsltPath ? this.state.data.xsltPath : this.getXSLT()}
                                                            clearable={false}
                                                            placeholder="Seçiniz..."
                                                            noResultsText="Kayıt bulunamadı."
                                                            onChange={(e) => e && this.onChangeValue({
                                                                name: "xsltPath",
                                                                value: e.value
                                                            })}
                                                            options={this.state.xslts.map(xslt => ({
                                                                value: xslt.xsltFilepath,
                                                                label: xslt.xsltFilename
                                                            }))}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 baseDashboard" style={{marginTop: '10px'}}>
                        <SigortaLines
                            listener={this.setTrdDocSigortaLines}
                            manual={this.state.manual}
                            errorListener={this.errorListener}
                            error={this.state.error}
                            trdDocSigortaLines={this.state.data.trdDocSigortaLines}
                            currentUser={this.props.currentUser}
                        />
                    </div>
                    <div className="col-sm-12" style={{marginTop: '10px'}}>
                        <div className=" row baseDashboard">
                            <div className="col-sm-7">
                                <div className="card-header">
                                    <h4 className="card-title">Açıklama</h4>
                                </div>
                                <div className="card-body">
                                    <NoteList listener={this.setTrdDocSigortaNotes}
                                              errorListener={this.errorListener}
                                              manual={this.state.manual}
                                              isManual={this.isManual}
                                              error={this.state.error}
                                              notes={this.state.data.trdDocSigortaNotes}
                                              type="Sigorta"
                                    />
                                </div>
                            </div>
                            <hr></hr>
                            <div className="col-sm-5 row">
                                <div className="card-header">
                                    <h4 className="card-title">Toplamlar</h4>
                                </div>
                                <div className="col-sm-12">
                                    <div className="card-body">
                                        <SigortaTotalList
                                            data={this.state.data}
                                            type="sigorta"
                                            suffix={this.state.suffix}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CreateEditSigorta;